var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.872 25.24c0-1.712-.154-3.359-.439-4.94H24.692v9.341h12.995c-.56 3.018-2.261 5.576-4.819 7.288v6.058h7.804c4.566-4.203 7.2-10.394 7.2-17.747z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.691 48.837c6.52 0 11.986-2.162 15.98-5.85l-7.803-6.059c-2.162 1.45-4.928 2.305-8.177 2.305-6.289 0-11.612-4.247-13.51-9.954H3.112v6.256c3.973 7.891 12.14 13.302 21.578 13.302z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.18 29.28a14.516 14.516 0 01-.757-4.589c0-1.591.275-3.139.758-4.587v-6.257H3.113A24.137 24.137 0 00.545 24.691c0 3.897.933 7.585 2.568 10.844l8.068-6.256z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.691 10.148c3.545 0 6.728 1.219 9.23 3.611l6.926-6.925C36.666 2.937 31.2.544 24.691.544c-9.439 0-17.605 5.412-21.578 13.303l8.067 6.256c1.899-5.707 7.222-9.955 13.511-9.955z",
    fill: "#EA4335"
  })));
}

export default SvgGoogleLogo;